export default {
    BASE_URL: "BASE_URL_STATIQ",
    BASE_URL_V2: "BASE_URL_STATIQ_V2",
    BASE_LAT: 28.7041,
    BASE_LONG: 77.1025,
    RAZORPAY_KEY: "RAZOR_PAY_API_KEY",
    GIT_VERSION: "GIT_RELEASE",
};